export var WidgetType;
(function (WidgetType) {
    WidgetType["text"] = "text";
    WidgetType["image"] = "image";
    WidgetType["textOnImage"] = "textOnImage";
    WidgetType["pdf"] = "pdf";
    WidgetType["video"] = "video";
    WidgetType["question"] = "question";
    WidgetType["html"] = "html";
    WidgetType["hiddenArea"] = "hiddenArea";
    WidgetType["fillInQuestion"] = "fillInQuestion";
    WidgetType["multipleResponseQuestion"] = "multipleResponseQuestion";
    WidgetType["sortation"] = "sortation";
    WidgetType["audio"] = "audio";
    WidgetType["interactiveProcess"] = "interactiveProcess";
    WidgetType["imageCarousel"] = "imageCarousel";
    WidgetType["interactiveTabs"] = "interactiveTabs";
    WidgetType["flipCard"] = "flipCard";
    WidgetType["labeledGraphic"] = "labeledGraphic";
    WidgetType["list"] = "list";
    WidgetType["divider"] = "divider";
})(WidgetType || (WidgetType = {}));
